import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

window.Pusher = Pusher

export const echo = new Echo({
    broadcaster: 'pusher',

    key: process.env.VUE_APP_PUSHER_APP_KEY,
    cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,

    forceTLS: true,

    authEndpoint: `${process.env.VUE_APP_API_URL}/api/broadcasting/auth`,

    auth: {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('supplier_token')}`,
            'X-Company-Id': localStorage.getItem('company_id') || '',
        },
    },
})